import React from "react";
import styles from "./Home.module.css";

const Home = () => {
  return (
    <div className={styles.pageContainer}>
      <section className={styles.hero}>
        {/* <h1>Efficient Invoicing System for Streamlined Business Operations</h1>
        <div className={styles.paragraph}>
          <p>
            Welcome to our advanced invoicing system designed to revolutionize
            the way you manage your business finances. Say goodbye to manual
            paperwork and administrative hassles. Our cutting-edge solution
            empowers you to effortlessly create, send, and track invoices,
            ensuring prompt payments and a healthier cash flow. Simplify your
            invoicing process, minimize errors, and maximize productivity with
            our user-friendly platform. Join us in embracing the future of
            business finance management
          </p>
        </div> */}
        <div className={styles.imgContainer}>
          <img
            src="https://i.postimg.cc/J00DZ8Mn/background.jpg"
            alt="invoicing-app"
          />
        </div>
      </section>
    </div>
  );
};

export default Home;
